<template>
    <div class="notification-management">
        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{dialog.title}}
            </div>

            <el-form :model="dialog.content" ref="formContent" label-width="112px">
                <el-form-item label="通知内容: ">
                    <el-input type="textarea" v-model="dialog.content" placeholder="请输入通知内容"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submit()">确定</el-button>
            </span>
        </el-dialog>
        <div class="el-card-title">
            <span>通知列表</span>
            <div :style="{ display: 'flex' }">
                <el-tooltip effect="dark" content="新增通知" placement="top">
                    <el-button type="text" @click="handleNotificationInsert">
                        <i class="mdi mdi-24px mdi-plus"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <custom-table :table="tableData" :options="{
            maxHeight: 640
        }"></custom-table>
    </div>
</template>

<script>
import { NotificationManagementApi } from '../http/notificationManagement/notificationManagement';
import CustomTable from '../components/customTable.vue';
export default {
    name: "notification-management",
    components: {
        CustomTable
    },
    data(){
        return {
            tableData: {
                data: [],
                columns: [],
                tableLoading: false
            },
            dialog: {
                title: "",
                visible: false,
                type: "",
                content: ""
            }
        }
    },
    mounted(){
        this.getNotificationList();
    },
    methods: {
        getNotificationList(){
            this.tableData.tableLoading = true;
            NotificationManagementApi.getNotificationList({
                pageSize: "10000",
                currentPage: "1"
            }).then(res => {
                this.tableData.tableLoading = false;
                Object.assign(this.tableData, res);
            })
        },
        handleCancel(){
            this.dialog.visible = false;
            this.dialog.content = ""
        },
        handleNotificationInsert(){
            this.dialog.visible = true;
            this.dialog.title = "新增通知";
            this.dialog.type = 'insert';
        },
        submit(){
            NotificationManagementApi.insertNotification(this.dialog.content).then(res => {
                if(res.data.status === 200){
                    this.$notify.success({ title: '新增通知成功' });
                    this.handleCancel();
                    this.getNotificationList();
                }
            })
        }
    }
}
</script>

<style lang="less">
div.notification-management{
    // padding: 14px 20px;
}
</style>